/**
 * OcorrenciaTracking
 * @author Simpli CLI generator
 */
import {$, Helper, Request, Resource} from 'simpli-web-sdk'
import {ResponseSerialize} from 'simpli-web-sdk'
import {Carga} from '@/model/resource/Carga'
import {TipoOcorrencia} from '@/model/resource/TipoOcorrencia'
import {Responsavel} from '@/model/resource/Responsavel'
import {OcorrenciaTrackingCollection} from '@/model/collection/OcorrenciaTrackingCollection'

/* TODO: review generated class */
export class OcorrenciaTracking extends Resource {
  @ResponseSerialize(Carga)
  carga: Carga | null = null

  @ResponseSerialize(TipoOcorrencia)
  tipoOcorrencia: TipoOcorrencia | null = null

  @ResponseSerialize(Responsavel)
  responsavel: Responsavel | null = null

  idOcorrenciaTracking: number | null = null
  dataOcorrencia: string | null = null

  descricao: string | null = null
  idOcorrenciaExterna: number | null = null
  idOcorrenciaFk: number | null = null

  get $id() {
    /* TODO: define the ID */
    return 0
  }
  set $id(val) {
    /* TODO: define the ID */
  }

  get idResponsavelFk() {
    if (!this.responsavel) return 0
    return this.responsavel.$id
  }
  set idResponsavelFk(val) {
    if (!this.responsavel) this.responsavel = new Responsavel()
    this.responsavel.$id = val
  }

  get idCargaFk() {
    if (!this.carga) return 0
    return this.carga.$id
  }
  set idCargaFk(val) {
    if (!this.carga) this.carga = new Carga()
    this.carga.$id = val
  }

  /**
   * Gets a instance of a given ID of OcorrenciaTracking
   */
  async getOcorrenciaTracking(id: number) {
    return await Request.get(`/admin/ocorrencia-tracking/${id}`)
      .name('getOcorrenciaTracking')
      .as(this)
      .getData()
  }

  /**
   * Lists the instances of OcorrenciaTracking
   */
  static async listOcorrenciaTracking(params: any) {
    return await Request.get(`/admin/ocorrencia-tracking`, {params})
      .name('listOcorrenciaTracking')
      .as(OcorrenciaTrackingCollection)
      .getData()
  }

  /**
   * Persists a new instance of OcorrenciaTracking. Use ID = 0 to create a new one,
   * or ID > 0 to update a current one
   */
  async persistOcorrenciaTracking() {
    return await Request.post(`/admin/ocorrencia-tracking`, this)
      .name('persistOcorrenciaTracking')
      .asNumber()
      .getData()
  }

  /**
   * Lists the instances of OcorrenciaTracking to use it in a CSV file
   */
  static async listCsvOcorrenciaTracking(params: any) {
    return await Request.get(`/admin/ocorrencia-tracking/csv`, {params})
      .name('listCsvOcorrenciaTracking')
      .as(OcorrenciaTrackingCollection)
      .getData()
  }
}
